// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/en"
import Methodology from "src/components/pages/Methodology/Methodology"

const MethodologyPageEn = ({ location, data }) => {
  const topNav = data.topNav
  const methodology = data.methodology
  const productSections = _.get(data, `product.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={methodology}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <Methodology
        methodology={methodology}
        productSections={productSections}
        language="en"
      />
    </Layout>
  )
}

export default MethodologyPageEn

export const query = graphql`
  query MethodologyPageEnQuery($id: String, $productId: String) {
    topNav: strapiTopNav(locale: { eq: "en" }) {
      ...topNavContent
    }

    methodology: strapiMethodology(id: { eq: $id }) {
      ...methodology
    }

    product: strapiPage(id: { eq: $productId }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "en" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "en" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
